import React from 'react';
import styled from 'styled-components';
import bodLogo from '../assets/images/bod-logo.svg';
import { useStoreState } from '../store';
import { PlayerStatus } from '../typings';

export function LoadingOverlay() {
  const playerReady = useStoreState(state => state.player.playerReady);
  const status = useStoreState(state => state.player.status);
  const castState = useStoreState(state => state.chromecast.castState);

  return playerReady === false || status === PlayerStatus.Buffering || castState === 'CONNECTING' ? (
    <Container>
      <LoadingIcon>
        <SpinnerOne />
        <SpinnerTwo />
        <SpinnerThree />
      </LoadingIcon>
      <BodLogo src={bodLogo} />
    </Container>
  ) : null;
}

const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BodLogo = styled.img`
  border-radius: 50%;
  position: absolute;
`;

const LoadingIcon = styled.div`
  width: 100px;
  height: 100px;
`;

const Spinner = styled.div`
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 100px;
  height: 100px;
  border: 2px solid transparent;
  border-radius: 50%;
  animation: spin 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-top: ${({ theme }) => `2px solid ${theme.primaryBlue}`};
`;

const SpinnerOne = styled(Spinner)`
  animation-delay: -0.3s;
`;

const SpinnerTwo = styled(Spinner)`
  animation-delay: -0.2s;
`;

const SpinnerThree = styled(Spinner)`
  animation-delay: -0.1s;
`;
